import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import classes from './SelectQueues.module.scss';

import FormControlLabel from '@mui/material/FormControlLabel';
import {ToggleStyle} from './ToggleStyle';


function SelectQueues({
  queuesList,
  selectedQueues,
  withData,
  handleQueueSelectionForStats,
  onIfWithDataHandler
}) {
  const [queueOptions, setQueueOptions] = useState(queuesList);
  const [selectedQueueForStats, setSelectedQueuesForStats] =
    useState(selectedQueues);
  const [ifWithData, setIfWithData] = useState(withData);


  useEffect(() => {
    setQueueOptions(queuesList);
  }, [queuesList]);
  useEffect(() => {
    setSelectedQueuesForStats(selectedQueues);
  }, [selectedQueues]);
  useEffect(() => {
    setIfWithData(withData);
  }, [withData]);

  return (
    <div className={classes['queuesSelect_wrap']}>
      <h6>Select Queues for Statistics:</h6>
      <div className={classes['queuesInput_wrap']}>
        <Select
          isMulti
          options={queueOptions}
          value={queueOptions.filter((option) =>
            selectedQueueForStats.includes(option.value)
          )}
          onChange={handleQueueSelectionForStats}
          className={classes['queue-select']}
          placeholder="Select Queue for Statistics"
        />
        <div className={classes['checkboxInput_wrap']}>
          <FormControlLabel
            checked={ifWithData}
            onChange={onIfWithDataHandler}
            control={<ToggleStyle />}
            label="with stats only"
          />
        </div>
      </div>
    </div>
  );
}

export default SelectQueues;
